var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 82,
    viewBox: "0 0 98 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 83
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1391 36.9517L11.1485 36.6916L11.2567 35.6548C12.3806 24.8823 16.8624 16.3666 23.4889 10.5411C30.1209 4.71072 38.9866 1.50049 49 1.50049C59.0134 1.50049 67.8791 4.71072 74.5111 10.5411C81.1376 16.3666 85.6194 24.8823 86.7433 35.6548L86.8514 36.6916L87.8609 36.9517C91.4119 37.8668 93.7023 39.6867 95.0211 41.8126C96.3508 43.956 96.7609 46.5207 96.3439 49.0198C95.5059 54.041 91.4049 58.5305 85.2272 58.5305H84.2359L83.8472 59.4424C77.8527 73.5086 65.0804 80.5005 49 80.5005C32.9196 80.5005 20.1472 73.5086 14.1528 59.4424L13.7641 58.5305H12.7728C6.59511 58.5305 2.4941 54.041 1.65613 49.0198C1.23906 46.5207 1.64917 43.956 2.97886 41.8126C4.29768 39.6867 6.58807 37.8668 10.1391 36.9517Z",
    fill: "#FFD5B1",
    stroke: "#FAA487",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5135 38.4042L12.5323 37.884L12.7486 35.8104C13.8369 25.3792 18.1607 17.2225 24.4793 11.6677C30.8089 6.10313 39.3111 3.00049 49 3.00049C58.6889 3.00049 67.1911 6.10314 73.5207 11.6677C79.8393 17.2225 84.1631 25.3792 85.2514 35.8104L85.4677 37.884L87.4865 38.4042C90.7033 39.2332 92.6521 40.8392 93.7465 42.6033C94.8627 44.4025 95.2285 46.5907 94.8643 48.7729C94.1283 53.183 90.5637 57.0305 85.2272 57.0305H83.2446L82.4673 58.8544C76.7554 72.2575 64.6086 79.0005 49 79.0005C33.3914 79.0005 21.2446 72.2575 15.5327 58.8544L14.7554 57.0305H12.7728C7.43633 57.0305 3.87166 53.183 3.13567 48.7729C2.77149 46.5907 3.13733 44.4025 4.2535 42.6033C5.34794 40.8392 7.29669 39.2332 10.5135 38.4042Z",
    fill: "#FFD5B1",
    stroke: "#FAA487",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9994 -2.00049C63 7.99951 63.6114 27.4491 47.4962 28.0026C32.9998 28.5005 34.9997 7.00045 49.9964 13.0028",
    stroke: "#B04700",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 44,
    rx: 4.5,
    ry: 7,
    fill: "#B04700"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.5,
    cy: 44,
    rx: 4.5,
    ry: 7,
    fill: "#B04700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8212 56.9285C42.7989 56.5196 43.0915 55 44.1926 55H53.8074C54.9085 55 55.2011 56.5196 54.1788 56.9285L50.4856 58.4058C49.5319 58.7872 48.4681 58.7872 47.5144 58.4058L43.8212 56.9285Z",
    fill: "#C56E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 64C39 64 42.3333 67 49 67C55.6667 67 59 64 59 64",
    stroke: "#C56E00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.529e22c43a5888a2aa004ed31fc7d0dd.svg";
export { ForwardRef as ReactComponent };